import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const CloseIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M13.7,2.3c.4.4.4,1,0,1.4l-4.2,4.2,4.2,4.2h0c.3.5.3,1,0,1.4-.4.4-.9.4-1.3,0h0c0,0-4.2-4.3-4.2-4.3l-4.2,4.2c-.4.4-1,.4-1.4,0-.4-.4-.4-1,0-1.4l4.2-4.2L2.3,3.8c-.4-.4-.4-1,0-1.4.4-.4,1-.4,1.4,0l4.2,4.2,4.2-4.2c.4-.4,1-.4,1.4,0Z" />
    </SvgIcon>
  );
};
